<!-- =========================================================================================
  File Name: DataListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <password-view-sidebar :isSidebarActive="addPasswordSidebar" @closeSidebar="togglePassswordSidebar" :data="passwordSidebarData" />
    <invite-student-sidebar :isStudentSidebarActive="addNewStudentSidebar" @closeStudentSidebar="toggleStudnetSidebar" :data="studentSidebarData" />
    <user-setting-sidebar :isUserSettingSidebarActive="addSettingSidebar" @closeSidebar="toggleUserSettingDataSidebar" :data="userSidebarSettingData" />
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
    <schedule-view-sidebar :isSidebarActive="addScheduleSidebar" @closeSidebar="toggleScheduleSidebar" :data="scheduleData" />
    <!-- ADD NEW -->
    <div>
    <vs-button class="user_add_btn" type="filled" @click="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> {{ $t('user.add.title') }}</vs-button>
    <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
  </div>
    <vs-table ref="table"  pagination :max-items="itemsPerPage" search
              :data="filteredUserList">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="select>0" vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">{{ $t('common.action') }} ({{selected.length}})</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <!-- <vs-dropdown-item>
                <span class="flex items-center"  @click="EmailConfirmed('email')">
                  <feather-icon icon="MailIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Confirm Email</span>
                </span>
              </vs-dropdown-item> -->
              <vs-dropdown-item>
                <span class="flex items-center"  @click="EmailConfirmed('status')">
                  <feather-icon icon="ToggleRightIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Enable</span>
                </span>
              </vs-dropdown-item>
               <vs-dropdown-item>
                <span class="flex items-center"  @click="EmailConfirmed('disablestatus')">
                  <feather-icon icon="ToggleLeftIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Disable</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span class="flex items-center" @click="EmailConfirmed('deleteuser')">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

              <!-- <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t('common.archive') }}</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t('common.print') }}</span>
                </span>
              </vs-dropdown-item> -->

            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- FILTER -->
          <!-- FILTER -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter">{{ $t('user.filters.search_by_location') }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="setSelected('Search By Location')">
                <span class="flex items-center">
                  <span  >All</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="location in locations" :key="location.id" @click="setSelected(location.name)">
                <span class="flex items-center">
                  <span >{{ location.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- ADD NEW -->
<!--          <div-->
<!--            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"-->
<!--            @click="addNewData">-->
<!--            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>-->
<!--            <span class="ml-2 text-base text-primary">Add New</span>-->
<!--          </div>-->
          <vx-tooltip text="Search By Status" position="top">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter_status">{{ $t('user.filters.search_by_status') }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="statusSelected('Search By Status')">
                <span class="flex items-center">
                   <span  >{{ $t('user.filters.all') }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="status in statuses" :key="status.id" @click="statusSelected(status.name)">
                <span class="flex items-center">
                  <span >{{ status.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>


        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ cam_users.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : cam_users.length }} of {{ queriedCamUsers }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <!-- <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item> -->
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-checkbox v-model="headCheckbox" @input="CheckAll()"></vs-checkbox>
        <vs-th>{{ $t('user.table.image') }}</vs-th>
        <vs-th>
        <span  @click="sorting('name')">{{ $t('user.table.name') }}</span>
        <feather-icon v-if="order && namestate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-2" @click="sorting('name')" />
        <feather-icon v-if="!order && namestate" icon="ChevronUpIcon" svgClasses="h-4 w-4" class="ml-2" @click="sorting('name')" /></vs-th>
        <vs-th>{{ $t('user.table.student') }}</vs-th>
        <vs-th>{{ $t('user.table.cameras') }}</vs-th>
        <!-- <vs-th>
        <span  @click="sortingpending('pending')">APPROVED</span>
        <feather-icon v-if="pendingorder && pendingstate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingpending('pending')" />
        <feather-icon v-if="!pendingorder && pendingstate" icon="ChevronUpIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingpending('pending')" />
        </vs-th> -->
         <vs-th>
        <span  @click="sortingstatus('status')">{{ $t('user.table.status') }}</span>
        <feather-icon v-if="statusorder && statusstate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingstatus('status')" />
        <feather-icon v-if="!statusorder && statusstate" icon="ChevronUpIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingstatus('status')" /></vs-th>
        <vs-th>{{ $t('user.table.action') }}</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td><vs-checkbox  @input="SelectItem(tr.id)" v-model="selectedCheck[indextr]" ref="checkbox"></vs-checkbox></vs-td>
            <vs-td class="img-container" v-if="tr.avatar">
               <router-link :to="{ path: '/'+ $t('route.user_profile.title') +'/'+ tr.id}" class="text-inherit">
                 <div class="relative inline-flex mx-auto">
                    <vs-avatar class="m-0 " :src="img_cdn + tr.avatar" size="50px" />
                    <div class="h-5 w-5 border-white border-2 border-solid rounded-full absolute right-0 bottom-0" :class="'bg-' + getStatusColor(tr.last_login_time)"></div>
                </div>
                </router-link>
            </vs-td>
            <vs-td v-else>
               <router-link :to="{ path: '/'+ $t('route.user_profile.title') +'/' + tr.id}" class="text-inherit">
              <div  class='icon-container'>
              <p class="bg-primary image-circle text-white" :data-letterstudent=tr.fname[0].toUpperCase()></p>
              <div class='status-circle ' :class="'bg-' + getStatusColor(tr.last_login_time)">
             </div>
             </div>
            </router-link>
            </vs-td>
            <!-- <vs-td class="img-container" v-else>
               <div class="relative inline-flex">
                 <p :data-letters=tr.fname[0].toUpperCase()></p>
                  <div class="h-5 w-5 border-white border-2 border-solid rounded-full absolute right-0 bottom-0" :class="'bg-success'"></div>
                  </div>
            </vs-td> -->
              <vs-td>
                <router-link :to="{ path: '/'+ $t('route.user_profile.title') +'/' + tr.id}" class="text-inherit">
                <p class="product-name font-small text-sm truncate">{{ tr.fname }} {{ tr.middle_name }} {{ tr.lname }} </p>
                <p class="product-name font-small text-sm truncate"><a :href="`tel:${tr.phone}`" @click.stop="">{{ tr.phone }}</a></p>
                <p class="product-name font-small text-sm truncate"><a :href="`mailto:${tr.email}`" @click.stop="">{{ tr.email }}</a></p>
               </router-link>
              </vs-td>
              <vs-td>
                <div v-for="(student) in tr.students" :key="student.id">
                  <vs-chip>
                    <router-link v-if="lng!='dogs'"
                                 :to="{ path: '/'+ $t('route.student_profile.title') +'/' + student.id}">
                      {{ student.fname }} {{ student.middle_name }} {{ student.lname }}
                    </router-link>
                    <router-link v-else :to="{ path: '/'+ $t('route.student_profile.title') +'/' + student.id}">
                      {{ student.fname }}
                    </router-link>
                    <!-- <feather-icon icon="UserXIcon" svgClasses="h-4 w-4" class="ml-2 "  @click="removeStudent(student.id,tr.id)"/> -->
                  </vs-chip>
                </div>

              </vs-td>
              <vs-td>
                <div>

                  <vx-tooltip class="vs-display" v-for="item in getCamerasList(tr.students)" :key="item.id" :text="item.name"
                              position="top">
                    <span :style="{background: item.color_code}" class="w-4 h-4 round" style="float: left"></span>
                  </vx-tooltip>
                </div>
              </vs-td>
              <!-- <vs-td>
                <p class="product-category"><a :href="`mailto:${tr.email}`" @click.stop="">{{ tr.email }}</a></p>
              </vs-td> -->
              <!-- <vs-td v-if="tr.pending==1">
                <vs-switch @input="confPendingEmail(tr)" v-model="tr.approved"></vs-switch>
              </vs-td>
              <vs-td v-else>Yes</vs-td> -->
              <!-- <vs-td v-if="tr.pending==1">
                <vs-switch @input="confEmail(tr)" v-model="tr.status">Pending</vs-switch>
              </vs-td> -->
              <vs-td v-if="tr.invited">
                Invited
              </vs-td>
              <vs-td v-else-if="tr.pending">
                Pending
              </vs-td>
               <vs-td v-else> <vs-switch @input="updateStatus(tr)" v-model="tr.status"></vs-switch>
              </vs-td>
              <vs-td class="whitespace-no-wrap">

                <!-- ACTION - DROPDOWN -->
                <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
                  <div>
                    <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" />
                  </div>

                  <vs-dropdown-menu>
                <vs-dropdown-item>
                  <span class="flex items-center">
                  <router-link :to="{ path: '/'+ $t('route.user_profile.title') +'/' + tr.id}" class="text-inherit " >
                 <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                 <span> View </span>
                </router-link>
                </span>
                </vs-dropdown-item>

                 <vs-dropdown-item>
                <span class="flex items-center" @click="editData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span> {{ $t('common.edit') }} </span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="confirmDeleteRecord(tr)">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>{{ $t('common.delete') }}</span>
                </span>
                    </vs-dropdown-item>

                    <vs-dropdown-item>
                <span class="flex items-center" @click="passwordData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('user.action.password-reset') }}</span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="userSettingData(tr)">
                  <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('user.action.settting') }}</span>
                </span>
                    </vs-dropdown-item>
                <vs-dropdown-item>
                <span class="flex items-center" @click="addSchedule(tr)">
                  <feather-icon icon="CalendarIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('user.action.schedule') }}</span>
                </span>
                </vs-dropdown-item>
                  <vs-dropdown-item v-if="tr.pending==1">
                <span class="flex items-center" @click="confPendingEmail(tr)">
                  <feather-icon icon="ToggleRightIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Approve</span>
                </span>
                </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>


            </vs-tr>
          </tbody>
        </template>
    </vs-table>
       <div class="demo-alignment">
      <div class="fill-row-loading">
        <div :class="{'activeLoading':activeLoading}"  :id="[`loading-sound`]" class="vs-con-loading__container loading-example">
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import UserSettingSidebar from './userSettingSideBar.vue'
import DataViewSidebar from './DataViewSidebar.vue'
import InviteStudentSidebar from "./InviteStudentSidebar"
import PasswordViewSidebar from './PasswordViewSidebar'
import ScheduleViewSidebar from './ScheduleViewSidebar'
import moment from "moment";
import {
  ALL_LOCATIONS,
  ALL_USERS,
  ME_DATA,
  REMOVE_USER,
  UPDATE_USER,
  UPDATE_USER_ACTIVITY,
  USER_EMAIL_CONFIRMED,
  USERS_BY_MANAGER_LOCATION,
  UPDATE_USER_STATUS
} from '@/graphql'

export default {
  components: {
    DataViewSidebar,
    InviteStudentSidebar,
    UserSettingSidebar,
    PasswordViewSidebar,
    ScheduleViewSidebar,
    moment
  },
  data () {
    return {
      StudentCameras: [],
      selectedCheck: [],
      headCheckbox: '',
      img_cdn: '',
      lng: '',
      cam_users: [],
      locations: [],
      custom_search_filter: 'Search By Location',
      custom_search_filter_status: 'Search By Status',
      statuses: [
        {
          id: '1',
          name: 'Active'
        },
        {
          id: '2',
          name: 'Disabled'
        },
        {
          id: '3',
          name: 'Pending'
        },
        {
          id:'4',
          name:'Offline'
        },
        {
          id:'5',
          name:'Online'
        },
        {
          id:'6',
          name:'Invited'
        }
      ],
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      activeLoading:false,
      // Data Sidebar
      addNewDataSidebar: false,
      addNewSettingDataSidebar: false,
      addSettingSidebar: false,
      sidebarData: {},
      userSidebarSettingData: {},
      addNewStudentSidebar: false,
      studentSidebarData: {},
      addPasswordSidebar:false,
      passwordSidebarData:{},
      scheduleData:{},
      addScheduleSidebar:false,
      DeleteItem:'',
      order:false,
      statusorder:true,
      pendingorder:true,
      namestate:false,
      statusstate:false,
      pendingstate:false
    }
  },
  computed: {
    filteredUserList: function () {
      var parameter = this.$route.params.status
      var custom_search_filter_status = this.custom_search_filter_status
      var custom_search_filter = this.custom_search_filter
      return this.cam_users.filter(function(cam_user) {
      if(parameter!='pending' && parameter!='online'){
        if( custom_search_filter_status != 'Search By Status' && custom_search_filter == 'Search By Location')

        {
          if(custom_search_filter_status=="Active"){
             if(cam_user.pending==0 && cam_user.status==1){
                return true
             }
            return false
          }
          if(custom_search_filter_status=="Disabled"){
             if(cam_user.status==0){
                return true
             }
            return false
          }
          if(custom_search_filter_status=="Pending"){
             if(cam_user.pending==1){
                return true
             }
            return false
          }
           if(custom_search_filter_status=="Invited"){
             if(cam_user.invited==1){
                return true
             }
            return false
          }
          if(custom_search_filter_status=="Offline"){
          if(cam_user.last_login_time){
          var val = moment(cam_user.last_login_time).format("YYYY-MM-DD HH:mm")
          var today = new Date();
          var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
          date= moment(date).format("YYYY-MM-DD")
          for (let i = 0; i < 6; i++) {
          var time= moment().utc().subtract(i, 'minutes').format('LTS');
          var time = moment(time, ["h:mm A"]).format("HH:mm");
          var dateTime = date+' '+time;
          var condition = val==dateTime
          if(condition){
            return false
          }
        }
         return true
       }
        return true
          }
          if(custom_search_filter_status=="Online"){
          if(cam_user.last_login_time){
          var val = moment(cam_user.last_login_time).format("YYYY-MM-DD HH:mm")
          var today = new Date();
          var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
          date= moment(date).format("YYYY-MM-DD")
          for (let i = 0; i < 6; i++) {
          var time= moment().utc().subtract(i, 'minutes').format('LTS');
          var time = moment(time, ["h:mm A"]).format("HH:mm");
          var dateTime = date+' '+time;
          var condition = val==dateTime
          if(condition){
            return true
          }
       }
        return false
       }
        return false
        }
        }
        if (custom_search_filter == 'Search By Location') {

         return true;
        }
        if(custom_search_filter !== 'Search By Location'){
         for (var i=0 ;i<cam_user.locations.length; i++) {
            if(cam_user.locations[i].name == custom_search_filter){
              return true;
            }
          }
         return false
        }
        return false;
        }
       if(parameter=='pending'){
          if(cam_user.pending==1){
                return true
             }
            return false
       }
       if(parameter=='online'){
          if(cam_user.last_login_time){
          var val = moment(cam_user.last_login_time).format("YYYY-MM-DD HH:mm")
          var today = new Date();
          var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
          date= moment(date).format("YYYY-MM-DD")
         for (let i = 0; i < 6; i++) {
          var time= moment().utc().subtract(i, 'minutes').format('LTS');
          var time = moment(time, ["h:mm A"]).format("HH:mm");
          var dateTime = date+' '+time;
          var condition = val==dateTime
          if(condition){
            return true
          }
       }
        return false
       }
        return false
       }
       return true
      });
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    select() {
      return this.selected.length
    },
   queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.cam_users.length
    },
    queriedCamUsers() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.cam_users.length
    }
  },
  methods: {
    sorting(name){
    this.namestate=true
    this.statusstate=false
    this.pendingstate=false
    var column=name
    this.statusorder=true
    this.pendingorder=true
    var order=this.order
    if(column=='name' && order==true){
    this.order=!this.order
    this.cam_users.sort(function(a, b) {
    var textA = a.fname.toUpperCase();
    var textB = b.fname.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
}
 if(column=='name' && order==false){
    this.order=!this.order
    this.cam_users.sort(function(a, b) {
    var textA = a.fname.toUpperCase();
    var textB = b.fname.toUpperCase();
    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
});
}
  } ,
  sortingstatus(name){
  this.namestate=false
  this.statusstate=true
  this.pendingstate=false
   var column=name
    this.order = true
    this.pendingorder = true
   var statusorder=this.statusorder
  if(column=='status' && statusorder==true){
    this.statusorder=!this.statusorder
    this.cam_users.sort(function(a, b) {
    var textA = a.status
    var textB = b.status
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
    if (column == 'status' && statusorder == false) {
      this.statusorder = !this.statusorder
      this.cam_users.sort(function (a, b) {
        var textA = a.status
        var textB = b.status
        return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
      });
    }
  },
    sortingpending(name) {
      this.namestate = false
      this.statusstate = false
      this.pendingstate = true
      var column = name
      this.order = true
      this.statusorder = true
      var pendingorder = this.pendingorder
      if (column == 'pending' && pendingorder == true) {
        this.pendingorder = !this.pendingorder
    this.cam_users.sort(function(a, b) {
    var textA = a.pending
    var textB = b.pending
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
});
}
 if(column=='pending' && pendingorder==false){
   this.pendingorder=!this.pendingorder
    this.cam_users.sort(function(a, b) {
    var textA = a.pending
    var textB = b.pending
    return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;
});
}
  } ,
    getCamerasList(students) {
      // console.log(students)
      let cameras = {}
      let unique_camera_ids = [];
      for (let i in students) {
        for (let j in students[i].cameras) {
          if (students[i].cameras[j] != null) {
            if (unique_camera_ids.indexOf(students[i].cameras[j].id) == -1) {
              unique_camera_ids.push(students[i].cameras[j].id)
              cameras[students[i].cameras[j].id] = students[i].cameras[j]
            }

          }
        }
      }
      return cameras

    },
    CheckAll() {
      var selected = []
      if (this.headCheckbox) {
        for (let index = 0; index < this.cam_users.length; index++) {
          this.selectedCheck[index] = true;
          selected.push(this.cam_users[index].id)
        }
        this.selected = selected
      } else {
        for (let index = 0; index < this.cam_users.length; index++) {
          this.selectedCheck[index] = false;
        }
        this.selected = []
      }
    },
    SelectItem(id) {
      if (!this.headCheckbox) {
        var status = false
        for (var i = 0; i < this.selected.length; i++) {
          if (this.selected[i] == id) {
            status = true
          }
        }
        if (status) {
          this.selected.pop(id)
        } else {
    this.selected.push(id)
  }
}
else{
    const index = this.selected.indexOf(id);
   if (index > -1) {
     this.selected.splice(index, 1);
  }
  else{
     this.selected.push(id)
  }
}
},
ConfirmNotification(status) {
      this.$vs.notify({
        title: this.$t('menu.users.name'),
        text: status +' Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
EmailConfirmed(action){
if(this.selected.length>0){
     this.$apollo
              .mutate({
                mutation: USER_EMAIL_CONFIRMED,
                variables: {
                  name: action,
                  user_ids: this.selected,
                }
              }).then(response => {
              if(response){
                this.ConfirmNotification(response.data.confirmUserEmail.status)
                this.selected=[];
                this.headCheckbox=false
                 for (let index = 0; index < this.selectedCheck.length; index++) {
                     this.selectedCheck[index]=false;
                 }
                this.get();
              }
            }).catch(error => {

            });

}
},
    confPendingEmail(tr) {
      tr.pending = false
      this.confEmail(tr)
    },
    confEmail(tr){
        var getlocationids = [];
          for (let j = 0; j< tr.locations.length; j++) {
          var getlocationid = tr.locations[j].id
          getlocationids.push(getlocationid)
        }
         tr.locations=getlocationids
          this.$apollo
          .mutate({
          mutation: UPDATE_USER,
          variables: {
          id :tr.id,
          fname:tr.fname,
          middle_name:tr.middle_name,
          lname: tr.lname,
          username: tr.username,
          phone:tr.phone,
          locations:tr.locations,
          email :tr.email,
          email_confirmed:tr.email_confirmed,
          pending: tr.pending,
          status:tr.status,
          avatar:tr.avatar,
          }
        })
          .then(response => {
                if (response) {
                  this.UpdateSuccess()
                  this.updateUserActivity(response.data.updateUser.id)

                }
              }).catch(error => {
              console.log(error)
            });
    },
    updateStatus(tr){

          this.$apollo
          .mutate({
          mutation: UPDATE_USER_STATUS,
          variables: {
          id :tr.id,
          status:tr.status,

          }
        })
          .then(response => {
                if (response.data.updateUserStatus.status='SUCCESS') {
                  this.UpdateSuccess()
                  this.updateUserActivity(response.data.updateUser.id)

                }
              }).catch(error => {
              console.log(error)
            });
    },
    updateUserActivity (id) {

      this.$apollo
        .mutate({
          mutation: UPDATE_USER_ACTIVITY,
          variables: {
            object_id: id,
            object_type:"App\\Models\\User",
            activity:"updated"
          }
        })
    },
      UpdateSuccess() {
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Updated Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
     StatusSuccess() {
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Deleted Successfully!',
        color: 'success',
        position: 'top-right'
      })},
    StatusInvalid() {
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Failed to Delete!',
        color: 'danger',
        position: 'top-right'
      })},
    setSelected(value) {

    // if(this.$router.params.status!='undefined'){
    //   this.$route.push('/users')
    //  }
      this.$route.params.status=''
      this.custom_search_filter = value;
    },
    statusSelected(value) {
    //   if(this.$route.params.status!='undefined'){
    //   this.$router.push('/users')
    //  }
      this.$route.params.status=''
      this.custom_search_filter_status = value;
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)

    },
    addNewStudent(data) {
      this.studentSidebarData = data
      this.toggleStudnetSidebar(true)

    },
      confirmDeleteRecord (cam_user) {
      this.DeleteItem=cam_user
      this.$vs.dialog({
        type: this.$t('common.alert.type'),
        color: 'danger',
        title: this.$t('common.alert.title'),
        text:  this.$t('common.alert.text') + `"${cam_user.fname} ${cam_user.lname}"`,
        accept: this.deleteData,
        acceptText: this.$t('common.alert.accept_text'),
        cancelText:this.$t('common.alert.cancel_text')
      })
    },
    deleteData () {
        this.$apollo
      .mutate({
        mutation: REMOVE_USER,
        variables: {
        id:  this.DeleteItem.id,
     },
      })
      .then(response => {
          this.get()
          if(response.data.deleteUser.status=='Success'){
            this.StatusSuccess()
          }
          else{
            this.StatusInvalid()
          }
        }).catch(error => {
         console.log(error)
      });
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    passwordData (data) {

      this.passwordSidebarData = data
      this.togglePassswordSidebar(true)
    },
    userSettingData (data) {

      this.userSidebarSettingData = data
      this.toggleUserSettingDataSidebar(true)

    },
     addSchedule (data) {
      this.scheduleData = data
      this.toggleScheduleSidebar(true)
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
      this.get()
    },
    toggleUserSettingDataSidebar (val = false) {
      this.addSettingSidebar = val
    },
    toggleStudnetSidebar (val = false) {
      this.addNewStudentSidebar = val
    },
      togglePassswordSidebar (val = false) {
      this.addPasswordSidebar = val
    },
      toggleScheduleSidebar (val = false) {
      this.addScheduleSidebar = val
      if(!val){
        this.get()
      }
    },
    removeStudent(student,user){
    },
      getStatusColor(val) {
        if(val){
        var val = moment(val).format("YYYY-MM-DD HH:mm")
        var today = new Date();
        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        date= moment(date).format("YYYY-MM-DD")
        for (let i = 0; i < 6; i++) {
          var time= moment().utc().subtract(i, 'minutes').format('LTS');
          var time = moment(time, ["h:mm A"]).format("HH:mm");
          var dateTime = date+' '+time;
          var condition = val==dateTime
          if(condition){
            return 'success'
          }
       }
       return 'grey'
      }
      else{
         return 'grey'
      }
      },

  get(){
    this.$apollo
      .mutate({
        mutation: ME_DATA,
      })
      .then(response => {
        this.conditionMethod(response.data.me.roles[0].name,response.data.me.id)
      }).catch(error => {
      console.log(error)
    });
  },
    conditionMethod(role,id){
    //  alert(role)
      if(role=="manager"){
      this.$apollo
      .mutate({
        mutation: USERS_BY_MANAGER_LOCATION,
        variables: {
        id:id
     },
      })
      .then(response => {
        var cameras=[]
        var users=[]
        var locations=[]
         for (let i = 0; i < response.data.userByLocation.managerlocations.length; i++) {
              locations.push(response.data.userByLocation.managerlocations[i])

            for (let j = 0; j < response.data.userByLocation.managerlocations[i].users.length; j++) {
                users.push(response.data.userByLocation.managerlocations[i].users[j])
              }
                for (let k= 0; k < response.data.userByLocation.managerlocations[i].cameras.length; k++) {
                cameras.push(response.data.userByLocation.managerlocations[i].cameras[k])
              }
         }
          const uniqueArray = users.filter((object,index) => index === users.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)));
          this.cam_users=uniqueArray
          this.cameras=cameras
          this.locations=locations
          // this.cam_users=users
          this.activeLoading = false
        this.$vs.loading.close()
        this.order = !this.order
        this.sorting('name')
      }).catch(error => {
          console.log(error)
      });
      }
      else {
        this.getUsersList()

      }
    },
    getUsersList () {
      this.$apollo
        .mutate({
          mutation: ALL_USERS,
        })
        .then(response => {
          this.cam_users = response.data.role.users
          this.order = !this.order
          this.sorting('name')
          this.activeLoading = false
          this.$vs.loading.close()
        })
      this.$apollo
      .mutate({
        mutation: ALL_LOCATIONS,
      })
      .then(response => {
        this.locations=response.data.locations
      })

    },
  },
  created () {
    this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
    this.lng=process.env.VUE_APP_I18N_LOCALE
    this.get()
    // this.getUsersList()
  },
  mounted () {
    this.isMounted = true
  },
    beforeCreate() {
    this.activeLoading = true
      this.$vs.loading({
        type:'sound',
      })

  }
}
</script>

<style lang="scss">

#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  .vs-display {
    display: inline-block
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */

    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
       .product-img {
                height: 70px;
                border-radius: 50%;
              }
   [data-letterstudent]:before {
  content:attr(data-letterstudent);
  }
  .image-circle{
  display:inline-block;
  font-size:35px;
  width:50px;
  height:50px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:1em;
  }
  .icon-container {
  width: 50px;
  height: 50px;
  position: relative;
}
.status-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color:transparent;
  border: 2px solid white;
  right: 0px;
  bottom: 0px;
  position: absolute;
}
  }
}
</style>
